(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('flip-card')) {
    class FlipCard extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.toggle.bind(this));
      }
      toggle() {
        this.classList.toggle('is-flipped');
      }
    }
    customElements.define('flip-card', FlipCard);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-page"]) return;
  try {
    
  document.querySelectorAll('.page--ebook-guide .rte p').forEach(function (p) {
    if (p.dataset.ebookCtaAdded) return;
    if (!p.textContent.includes('Deze gids is ontworpen')) return;
    p.dataset.ebookCtaAdded = 'true';
    var link = document.createElement('a');
    link.href = '#ebook-download-form';
    link.className = 'link underlined-link ebook-cta-link';
    link.textContent = 'Ontvang de gratis haargids';
    link.addEventListener('click', function (event) {
      event.preventDefault();
      var target = document.getElementById('ebook-download-form');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    var wrapper = document.createElement('p');
    wrapper.className = 'ebook-cta-paragraph';
    wrapper.appendChild(link);
    p.insertAdjacentElement('afterend', wrapper);
  });

  document.querySelectorAll('.page--ebook-guide .rte p').forEach(function (p) {
    if (p.dataset.ebookRewritten) return;
    var t = p.textContent.trim();
    if (t.indexOf('Ben je klaar met haarverzorgingsroutines') === 0) {
      p.dataset.ebookRewritten = 'true';
      p.innerHTML = "Ben je klaar met haarverzorgingsroutines die niet werken?<br>Stop met gokken wat je haar nodig heeft.<br>In 8 pagina's weet je precies welk type krul je hebt, waarom je haar droog blijft en welke routine écht werkt voor jou. Jouw krullen verdienen producten en routines die perfect aansluiten bij hun unieke behoeften.";
    } else if (t.indexOf('Dit is niet zomaar een e-book') === 0) {
      p.dataset.ebookRewritten = 'true';
      p.innerHTML = 'Dit is niet zomaar een e-book. hij is compact en krachtig, alles wat je nodig hebt, zonder overbodige info. <strong>Al meer dan 800 krullenbollen gingen je voor. Klaar in 15 minuten.</strong>';
    }
  });

  document.querySelectorAll('.page--ebook-guide .rte h3').forEach(function (h3) {
    if (h3.dataset.ebookRewritten) return;
    if (h3.textContent.trim() !== 'Wat kun je verwachten?') return;
    h3.dataset.ebookRewritten = 'true';

    var strong = h3.querySelector('strong');
    if (strong) {
      strong.textContent = 'In deze gratis gids ontdek je:';
    } else {
      h3.textContent = 'In deze gratis gids ontdek je:';
    }

    var ul = h3.nextElementSibling;
    if (ul && ul.tagName === 'UL') {
      var img = ul.querySelector('img');
      var imgWrapper = img ? img.closest('div') : img;
      var newP = document.createElement('p');
      newP.innerHTML = "<strong>✓</strong> Hoe je in 2 minuten je krultype bepaalt (type 2, 3 of 4)<br><strong>✓</strong> Waarom je haar altijd droog aanvoelt én hoe je dat stopt<br><strong>✓</strong> De juiste volgorde van producten (de meeste mensen doen dit fout)<br><strong>✓</strong> Plopping, scrunching &amp; diffusen, stap voor stap uitgelegd<br><strong>✓</strong> Welke ingrediënten je haar saboteren zonder dat je het weet";
      ul.replaceWith(newP);
      if (imgWrapper) newP.parentNode.insertBefore(imgWrapper, newP);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('h3, h4').forEach(function (heading) {
    if (!/WELKOM/.test(heading.textContent) || heading.dataset.countdownAdded) return;
    heading.dataset.countdownAdded = 'true';

    var timerText = document.createElement('p');
    var remaining = 5 * 60;
    var render = function () {
      var minutes = Math.floor(remaining / 60);
      var seconds = remaining % 60;
      timerText.textContent = 'Nog ' + minutes + ':' + String(seconds).padStart(2, '0') + ' geldig';
    };
    render();
    heading.insertAdjacentElement('afterend', timerText);

    var interval = setInterval(function () {
      remaining--;
      if (remaining <= 0) {
        remaining = 0;
        render();
        clearInterval(interval);
        return;
      }
      render();
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.testimonial-slider__list.slider').forEach(function (slider) {
    var items = slider.querySelectorAll('.testimonial-slider__item');
    if (items.length < 2) return;

    var paused = false;
    slider.addEventListener('mouseenter', function () { paused = true; });
    slider.addEventListener('mouseleave', function () { paused = false; });
    slider.addEventListener('touchstart', function () { paused = true; }, { passive: true });

    setInterval(function () {
      if (paused) return;
      var slideWidth = items[0].getBoundingClientRect().width;
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      var next = slider.scrollLeft + slideWidth;
      if (next > maxScroll - 5) next = 0;
      slider.scrollTo({ left: next, behavior: 'smooth' });
    }, 4500);
  });

  } catch(e) { console.error(e); }
})();
})();
